import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useState, createContext, useContext, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { preventDefault } from '#modules/browser';

const TextInputContext = createContext();

TextInput.propTypes = {
  small: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  value: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'password']),
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};
export default function TextInput({
  small = false,
  className,
  value,
  type = 'text',
  onChange,
  onFocus = () => {},
  onBlur = () => {},
  disabled = false,
  children,
  ...inputProps
}) {
  const handleChange = (event) => onChange(event);

  const [focused, setFocused] = useState(false);
  const handleFocus = (event) => {
    setFocused(true);
    onFocus(event);
  };
  const handleBlur = (event) => {
    setFocused(false);
    onBlur(event);
  };

  const hasCounter = children?.type === Counter;
  const hasTask = children?.type === Task;
  const [maxLength, setMaxLength] = useState();
  const elemRef = useRef();

  return (
    <div
      className={classNames('input_cover', {
        has_counter: hasCounter,
        has_task: hasTask,
      })}
    >
      <input
        {...inputProps}
        ref={elemRef}
        type={type}
        className={classNames(
          small ? 'lw_input_32' : 'lw_input',
          {
            focus: focused,
            disabled,
          },
          className,
        )}
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled}
        maxLength={maxLength}
      />
      <TextInputContext.Provider
        value={{ value, setMaxLength, elem: elemRef.current }}
      >
        {hasCounter && children}
        {hasTask && focused && children}
      </TextInputContext.Provider>
    </div>
  );
}
TextInput.Counter = Counter;
TextInput.Task = Task;

Counter.propTypes = {
  max: PropTypes.number.isRequired,
};
function Counter({ max }) {
  const { value, setMaxLength } = useContext(TextInputContext);
  useEffect(() => {
    setMaxLength(max);
  }, [max]);

  return (
    <div className="counter">
      <span className="text">
        <em className="point">{value.length}</em>/{max}
      </span>
    </div>
  );
}

Task.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
function Task({ onSave, onCancel }) {
  const { t } = useTranslation();
  const { elem } = useContext(TextInputContext);

  const handleMouseDownSave = () => onSave(elem);
  const handleMouseDownCancel = () => onCancel(elem);

  return (
    <div className="task">
      <button
        type="button"
        className="btn_save"
        onMouseDown={preventDefault(handleMouseDownSave)}
      >
        {t('button_save')}
      </button>
      <span className="bar"></span>
      <button type="button" onMouseDown={preventDefault(handleMouseDownCancel)}>
        {t('button_cancel')}
      </button>
    </div>
  );
}
